import React from "react";
import { PropTypes } from "prop-types";
import { DragDropList } from "common/components";
import { observer } from "mobx-react";
import { MrbPage, MrbPageHeader } from "mrb/components/layout";
import { NakiStoreHomeSection } from "administration/naki-store/components";
import { MrbButton } from "mrb/components/button";
import { MrbContentLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";
import { SectionListLoader } from "administration/naki-store/components";

function NakiStoreHomeSectionListTemplate({ nakiStoreHomeSectionListViewStore, t }) {
    return (
        <MrbPage store={nakiStoreHomeSectionListViewStore} t={t}>
            <MrbPageHeader>
                <div>Naki Store - Home Screen Sections</div>
                <Actions store={nakiStoreHomeSectionListViewStore} t={t} />
            </MrbPageHeader>

            <PanelHeader nakiStoreHomeSectionListViewStore={nakiStoreHomeSectionListViewStore} />

            <SectionList nakiStoreHomeSectionListViewStore={nakiStoreHomeSectionListViewStore} t={t} />
        </MrbPage>
    );
}

const SectionList = observer(function SectionList({ nakiStoreHomeSectionListViewStore, t }) {
    const { sections, reorderSections, loaderStore } = nakiStoreHomeSectionListViewStore;
    return (
        <div className="c-card--med c-card--primary u-mar--top--sml">
            <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <SectionListLoader />}>
                {() => (
                    <React.Fragment>
                        {sections.length > 0 && (
                            <div>
                                <DragDropList
                                    droppableId="naki-store-home-sections"
                                    items={sections}
                                    onDragEnd={reorderSections}
                                    itemRender={(item) => (
                                        <NakiStoreHomeSection
                                            id={item.id}
                                            nakiStoreHomeSectionListViewStore={nakiStoreHomeSectionListViewStore}
                                            t={t}
                                        />
                                    )}
                                ></DragDropList>
                            </div>
                        )}
                    </React.Fragment>
                )}
            </MrbContentLoader>
        </div>
    );
});

const Actions = observer(function Actions({ store, t }) {
    const { onClickSave, isSubmitting } = store;
    return (
        <React.Fragment>
            <MrbButton
                t={t}
                className="c-btn c-btn--base c-btn--primary"
                onClick={onClickSave}
                aria-label="Save"
                aria-busy={isSubmitting}
                label="Save"
                disabled={isSubmitting}
            />
        </React.Fragment>
    );
});

const PanelHeader = observer(function PanelHeader({ nakiStoreHomeSectionListViewStore }) {
    const { addSection, sections, isSubmitting, sectionsLimit, sectionsLimitReached } =
        nakiStoreHomeSectionListViewStore;
    const label = `Add Section (${sections.length}/${sectionsLimit})`;
    return (
        <div className="c-card--med c-card--primary">
            <MrbButton
                className="c-btn c-btn--med c-btn--ghost u-mar--right--sml"
                label={label}
                onClick={addSection}
                disabled={isSubmitting || sectionsLimitReached}
            />

            {sectionsLimitReached && (
                <div className="c-device-menu__note c-device-menu__note--secondary">
                    Maximum number of home screen sections reached.
                </div>
            )}
        </div>
    );
});

NakiStoreHomeSectionListTemplate.propTypes = {
    nakiStoreHomeSectionListViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(NakiStoreHomeSectionListTemplate);
